import { atom } from 'jotai';

export const tutorialOpenAtom = atom(false);
